"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _searchResults = _interopRequireDefault(require("./search-results"));

var _searchFilters = _interopRequireDefault(require("./search-filters"));

var _section = _interopRequireDefault(require("../section"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SearchBodyContainer = (0, _styledComponents["default"])(_section["default"]).withConfig({
  displayName: "search-body__SearchBodyContainer",
  componentId: "sc-1n9g0hh-0"
})(["height:calc(100vh - 75px);@media only screen and (max-width:550px){height:calc(100vh - 50px);}"]);
var propTypes = {
  // Currently active filters list
  activeFilters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),
  // Function to cancel search
  cancelSearch: _propTypes.func,
  // Container class name
  className: _propTypes.string,
  // Function to fetch more search results
  fetchMoreResults: _propTypes.func,
  // List of all search filters
  filters: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    label: _propTypes.string,
    value: _propTypes.string
  })),
  // Title for individual search filter
  filtersTitle: _propTypes.string,
  // Flag to show if search is loading
  isLoading: _propTypes.bool,
  // Function to be called when search filter change
  onChange: _propTypes.func,

  /** Search Results */
  results: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    className: _propTypes.string,
    description: _propTypes.string,
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string,
    url: _propTypes.string
  })),
  // Number of search results found
  resultsCount: _propTypes.number,

  /** Input onChange function */
  showLoadMoreResults: _propTypes.bool
};
var defaultProps = {
  filtersTitle: "Filter Results"
};
/**
 * Search bar includes Input Primitive with a search icon and a container for
 * suggested search terms.
 */

var SearchBody = function SearchBody(_ref) {
  var activeFilters = _ref.activeFilters,
      className = _ref.className,
      filters = _ref.filters,
      filtersTitle = _ref.filtersTitle,
      isLoading = _ref.isLoading,
      results = _ref.results,
      resultsCount = _ref.resultsCount,
      onChange = _ref.onChange,
      showLoadMoreResults = _ref.showLoadMoreResults,
      fetchMoreResults = _ref.fetchMoreResults,
      cancelSearch = _ref.cancelSearch;
  return /*#__PURE__*/_react["default"].createElement(SearchBodyContainer, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_searchResults["default"], {
    cancelSearch: cancelSearch,
    count: resultsCount,
    fetchMoreResults: fetchMoreResults,
    isLoading: isLoading,
    results: results,
    showLoadMoreResults: showLoadMoreResults
  }), /*#__PURE__*/_react["default"].createElement(_searchFilters["default"], {
    activeFilters: activeFilters,
    filters: filters,
    onChange: onChange,
    title: filtersTitle
  }));
};

SearchBody.propTypes = propTypes;
SearchBody.defaultProps = defaultProps;
SearchBody.displayName = "Modules.SearchBody";
var _default = SearchBody;
exports["default"] = _default;